import React from 'react'
import {IconButton, InputAdornment, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from './GridBlock';
import TitledComponent from './TitledComponent';
import Select from './Select';
import TextInput from './TextInput';
import Tr from 'translations/Translations';
import VATItems, {SELECT_VALUE} from 'constants/VATItems'
import getObjectValue from 'libs/getObjectValue';
import CloseIcon from '@material-ui/icons/Close'
import INPUT_TYPE from 'constants/INPUT_TYPE';
import toFloat from 'libs/toFloat';
import {calcGrossValue, calcNetValue} from "../libs/netGrosCalculations";
import {useDidUpdateEffect} from "../hooks/useDidUpdateEffect";
import {PriceType, PriceTypeNetFieldVisible, PriceTypeVatFieldVisible, PriceTypeGrossFieldVisible} from "constants/PriceTypes";

const style = theme => ({
	root: {

	},
	grid: {
		'&>*': {
			flexGrow: 1,
			'&:not(:first-child)': {
				marginLeft: theme.spacing(2)
			}
		}
	},
	iconButton: {
		padding: theme.spacing(1) / 2,
	},
	otherTextInput: {
		'& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
			'-webkit-appearance': 'none',
			margin: 0
		}
	},
	regularTitle: {
		fontWeight: theme.typography.fontWeightRegular,
	},
	vat: {
		marginBottom: '0px',
	}
})

function NetGrossField({
	classes,
	formikProps,
	id,
	pathPrefix,
	title,
	required,
	priceType = PriceType.NET_GROSS,
	noErrorMargin = false
}) {
	const net = !!pathPrefix ? `${pathPrefix}Value` : `${id}.value`;
	const gross = !!pathPrefix ? `${pathPrefix}GrossValue` : `${id}.grossValue`
	const option = !!pathPrefix ? `${pathPrefix}VatRate` : `${id}.vatRate`
	const optionOther = !!pathPrefix ? `${pathPrefix}VatRateOther` : `${id}.vatRateOther`


	const netValue = toFloat(getObjectValue(net, formikProps.values, 0))
	const grossValue = toFloat(getObjectValue(gross, formikProps.values, 0))
	const optionValue = getObjectValue(option, formikProps.values, null)
	const optionOtherValue = getObjectValue(optionOther, formikProps.values, '')
	const editable = getObjectValue('_editable', formikProps.values, true);

	const doCalcGrossValue = () => {
		const curGross = getObjectValue(gross, formikProps.values, 0);
		let newGrossValue = calcGrossValue(netValue, optionValue, optionOtherValue);
		if(newGrossValue !== undefined && curGross !== newGrossValue)
			formikProps.setFieldValue(gross, newGrossValue.toFixed(2))
	}

	const doCalcNetValue = () => {
		const newNetValue = calcNetValue(grossValue, optionValue, optionOtherValue);
		if(newNetValue !== undefined)
			formikProps.setFieldValue(net, newNetValue.toFixed(2))
	}

	useDidUpdateEffect(() => {
		doCalcGrossValue()
	}, [netValue, optionValue, optionOtherValue])

	const handleGrossBlur = () => {
		doCalcNetValue()
	}

	const closeTextInput = () => {
		formikProps.setFieldValue(option, "")
	}
	return (
		<TitledComponent
			title={title}
			required={required}
			labelClassName={!!pathPrefix ? classes.regularTitle : ''}
		>
			<GridBlock
				className={classes.grid}
				wrap='nowrap'
			>
				{PriceTypeNetFieldVisible(priceType) &&
					<TextInput
						id={net}
						formikProps={formikProps}
						label={Tr('net')}
						type={INPUT_TYPE.NUMBER_19}
						step="0.01"
						noErrorMargin={noErrorMargin}
					/>
				}

				{PriceTypeVatFieldVisible(priceType) &&
					(optionValue === SELECT_VALUE.OTHER ?
						<TextInput
							id={optionOther}
							formikProps={formikProps}
							className={classes.otherTextInput}
							label={Tr('vat')}
							type={INPUT_TYPE.NUMBER_POSITIVE_AMOUNT}
							endAdornment={
								<InputAdornment position='end'>
									%
									<IconButton
										onClick={closeTextInput}
										className={classes.iconButton}
										disabled={!editable}
									>
										<CloseIcon />
									</IconButton>
								</InputAdornment>
							}
							noErrorMargin={noErrorMargin}
						/>
						:
						<Select
							className={classes.vat}
							id={option}
							formikProps={formikProps}
							items={VATItems}
							label={Tr('vat')}
						/>
					)
				}

				{PriceTypeGrossFieldVisible(priceType) &&
					<TextInput
						id={gross}
						formikProps={formikProps}
						label={Tr('gross')}
						type={INPUT_TYPE.NUMBER_19}
						step="0.01"
						onBlur={handleGrossBlur}
						noErrorMargin={noErrorMargin}
					/>
				}
			</GridBlock>
		</TitledComponent>
	)
}

NetGrossField.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(NetGrossField);